module.exports = __webpack_public_path__ + "img/630.a7115a6f.jpg";